/** Texte ecran succes Nova Poshta (Moldova) — română. */
export const novaPoshtaMdSuccessCopy = {
  breadcrumbHome: 'Principală',
  breadcrumbServices: 'Servicii',
  breadcrumbCurrent: 'Urmărește coletul',
  title: 'Urmărește coletul',
  trackingLabel: 'Număr de urmărire:',
  track: 'Urmărire',
  help: 'Ajutor',
  copy: 'Copiază',
  statusTitle: 'Statusul coletului',
  statusLine1: 'Informațiile despre colet au fost introduse în sistem',
  statusLine2: 'Plata anticipată a fost efectuată de către destinatar',
  cta: 'Primește',
  deliveryInfoTitle: 'Informații despre livrare',
  recipientInfo: 'Informații despre destinatar:',
  characteristics: 'Caracteristici:',
  characteristicsValue: 'Încasare la livrare',
  description: 'Descriere (opțional):',
  productImage: 'Imagine produs (opțional):',
  needHelpTitle: 'Ai nevoie de ajutor suplimentar?',
  needHelpBody: 'Contactați suportul pentru informații suplimentare.',
  helpBtn: 'Ajutor',
  loading: 'Se încarcă…',
};

